import { takeEvery, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';

const {
  REQUEST_GET_PRESIGNED_URL,
  SUCCESS_GET_PRESIGNED_URL,
  FAILURE_GET_PRESIGNED_URL,
  LOADING_GET_PRESIGNED_URL,
} = documentBundleActions;

function* getPresignedUrl(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_PRESIGNED_URL });
    const response = yield call(documentBundleService.getPresignedUrl, action.jobId);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_PRESIGNED_URL, payload: response.data?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_PRESIGNED_URL, payload: error });
  }
}

function* getPresignedUrlSaga() {
  yield takeEvery(REQUEST_GET_PRESIGNED_URL, getPresignedUrl);
}

export default getPresignedUrlSaga;
export { getPresignedUrl };
